import { Action, ThunkAction, configureStore } from "@reduxjs/toolkit";
import {
  appReducer,
  columnReducer,
  homeReducer,
  podcastReducer,
  userReducer,
} from "./reducers";

import logger from "redux-logger";

export const store = configureStore({
  reducer: {
    app: appReducer,
    user: userReducer,
    podcast: podcastReducer,
    column: columnReducer,
    home: homeReducer,
  },
  middleware: (getDefaultMiddleware) =>
    process.env.NODE_ENV === "development"
      ? getDefaultMiddleware().concat(logger)
      : getDefaultMiddleware(),
  devTools: process.env.NODE_ENV === "development",
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
